import {useOrganizationData} from "@/data/app-data-hooks";
import {useMemo} from "react";
import {useBookmarks} from "@/data/user-data-hooks";

/**
 * Hook to get full video data for all bookmarked videos within an organization
 * Combines bookmark IDs with app data to return complete video objects
 */
export const useBookmarkedVideos = (orgId: string) => {
    const bookmarkIds = useBookmarks(orgId);

    // Get all media items from app data
    const {data: orgData} = useOrganizationData(orgId);

    // Filter videos to only include bookmarked ones
    const bookmarkedVideos = useMemo(() => {
        if (!orgData.media.items || bookmarkIds.length === 0) return [];

        return bookmarkIds.map(id => orgData.media.items[id] ?? null).filter(Boolean).reverse();
    }, [orgData, bookmarkIds]);

    return {
        videos: bookmarkedVideos,
        bookmarkIds,
        count: bookmarkedVideos.length,
    };
};
